import { Controller } from '@hotwired/stimulus'
import UserPreferences from 'models/user_preferences'

export default class extends Controller {
  async initialize() {
    this.preferences = new UserPreferences()
    this.preferenceName = this.element.dataset.preference

    const dbValue = await this.preferences.get(this.preferenceName)
    this._updateUiElement(dbValue)
  }

  async change(_event) {
    const dbValue = await this.preferences.get(this.preferenceName)
    const currentValue = this._getCurrentValue()
    if (currentValue !== dbValue) {
      await this.preferences.update(this.preferenceName, currentValue)
    }
  }

  _updateUiElement(_dbValue) {
    throw new Error("_updateUiElement must be implemented by PreferencesBaseController subclass")
  }

  _getCurrentValue() {
    throw new Error("_getCurrentValue must be implemented by PreferencesBaseController subclass")
  }
}
